var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppLogoUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 80,
    viewBox: "0 0 112 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 80,
    fill: "#F7F8F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.1324 53.3704H41.5588C40.9687 53.3704 40.4028 53.1362 39.9856 52.7195C39.5684 52.3027 39.334 51.7375 39.334 51.1481V25.2222C39.334 24.6329 39.5684 24.0676 39.9856 23.6509C40.4028 23.2341 40.9687 23 41.5588 23H59.3572C59.938 22.9997 60.4958 23.2262 60.9116 23.6311L65.3613 27.9022C65.5736 28.1094 65.7423 28.3568 65.8575 28.6301C65.9726 28.9034 66.0318 29.1969 66.0317 29.4933V33.7407",
    stroke: "#6B6C7E",
    strokeWidth: 2.22481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7559 43.0533H46.2738C45.9955 43.0533 45.7198 42.9985 45.4627 42.8921C45.2055 42.7857 44.9719 42.6298 44.7751 42.4332C44.3776 42.0362 44.1543 41.4977 44.1543 40.9362V33.8459C44.1543 33.5679 44.2091 33.2927 44.3157 33.0359C44.4222 32.7792 44.5783 32.5459 44.7752 32.3494C44.972 32.153 45.2057 31.9972 45.4628 31.8909C45.72 31.7847 45.9955 31.7301 46.2738 31.7303H48.3918L49.4523 29.6133H55.8078L56.855 31.7303H58.9745C59.2527 31.7301 59.5283 31.7847 59.7855 31.8909C60.0426 31.9972 60.2763 32.153 60.4731 32.3494C60.6699 32.5459 60.8261 32.7792 60.9326 33.0359C61.0391 33.2927 61.094 33.5679 61.094 33.8459V36.0681",
    stroke: "#6B6C7E",
    strokeWidth: 2.22481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6311 39.0851C53.8598 39.0851 54.8559 38.0901 54.8559 36.8628C54.8559 35.6355 53.8598 34.6406 52.6311 34.6406C51.4023 34.6406 50.4062 35.6355 50.4062 36.8628C50.4062 38.0901 51.4023 39.0851 52.6311 39.0851Z",
    stroke: "#6B6C7E",
    strokeWidth: 2.22481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6685 47.2465L65.2717 38.5547L57.875 47.2465H61.9093V56.3325H68.6342V47.2465H72.6685Z",
    stroke: "#6B6C7E",
    strokeWidth: 2.22481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppLogoUpload);
export default __webpack_public_path__ + "static/media/app-logo-upload.057f84fa55cf4bc51c79b447ef334df3.svg";
export { ForwardRef as ReactComponent };